import React, { Component } from 'react'
import { Button, Form, Input, message, Modal, Radio } from 'antd'
import _ from 'lodash'

import './UserManagementModal.scss'

const API_URL = process.env.API_URL
const FormItem = Form.Item
const RadioGroup = Radio.Group

export class UserManagementModal extends Component {
    constructor(props) {
        super(props)

        this.state = {
            visible: false
        }

        this.resizeFormHeight = this.resizeFormHeight.bind(this)
        this.handleSubmit = this.handleSubmit.bind(this)
    }

    resizeFormHeight() {
        this.setState({ formHeight: window.innerHeight * 0.8 - 82 })
    }

    checkUsername(rule, value, cb) {
        const { token, selectedUserId } = this.props

        if (!_.isEmpty(selectedUserId))
            cb()
        else
            fetch(`${API_URL}/auth/input-validate`, {
	                method: 'POST',
	                mode: 'cors',
	                headers: {
	                    'Authorization': `bearer ${token}`,
	                    'Content-Type': 'application/json'
	                },
	                body: JSON.stringify({ type: 'username', input: value })
	            })
	            .then((res) => res.json())
	            .then((json) => {
	                if (json.result.unique)
	                    cb()
	                else
	                    cb('This username is already taken.')
	            })
    }

    handleSubmit(e) {
        e.preventDefault()
        const { token, form, selectedUserId, addUser, updateUser, onCancel } = this.props

        form.validateFields((err, values) => {
            if (!err) {
                if (selectedUserId) {
                    updateUser(token, selectedUserId, values, (success) => {
                        if (success) {
                        	message.success('User successfully updated.')
                            onCancel()
                            form.resetFields()
                        } else
                            message.error('Failed to update the user. Something went wrong')
                    })
                } else {
                    addUser(token, values, (success) => {
                        if (success) {
                        	message.success('New user successfully added.')
                            onCancel()
                            form.resetFields()
                        } else
                            message.error('Failed to add the new user. Something went wrong')
                    })
                }
            }
        })
    }

    componentDidMount() {
        this.resizeFormHeight()
        window.addEventListener('resize', this.resizeFormHeight)
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.resizeFormHeight)
    }

    componentDidUpdate(prevProps, prevState) {
        const { fetchUser, token, form, visible, selectedUserId } = this.props
        if (visible && prevProps.visible !== visible) {
            if (_.isEmpty(selectedUserId)) {
                form.resetFields()
            } else {
                fetchUser(token, selectedUserId, (user) => {
                    form.setFieldsValue(user)
                })
            }
        }
    }

    render() {
        const { form, selectedUserId, visible, onCancel } = this.props
        const { formHeight } = this.state
        const isCreateNewUser = _.isEmpty(selectedUserId)
        const modalTitle = isCreateNewUser ? 'Add New User' : 'User Profile Management'

        const { getFieldDecorator } = form
        const formItemLayout = {
            labelCol: { span: 6 },
            wrapperCol: { span: 14 },
        }

        return (
            <Modal
            	className="UserManagementModal"
                width="60%"
                visible={visible}
                title={modalTitle}
                onCancel={onCancel}
                footer={null}
	        >
	        	<Form onSubmit={this.handleSubmit} style={{ maxHeight: formHeight, overflow: 'auto' }}>
	                <FormItem
	                    {...formItemLayout}
	                    label="User ID"
	                >
	                    { selectedUserId || '-' }
	                </FormItem>
	                <FormItem
	                    {...formItemLayout}
	                    label="Username"
	                >
                        {getFieldDecorator('username', {
                            rules: [
                                { required: true, message: 'Please input username.' },
                                { validator: this.checkUsername.bind(this) }
                            ],
                            validateTrigger: 'onBlur'
                        })(
                            <Input disabled={!isCreateNewUser}/>
                        )}
	                </FormItem>
	                <FormItem
	                    {...formItemLayout}
	                    label="Password"
	                >
                        {getFieldDecorator('password', {
                            rules: [
                                { required: isCreateNewUser, message: 'Please input user password.' },
                            ],
                            validateTrigger: 'onBlur'
                        })(
                            <Input type="password"/>
                        )}
	                </FormItem>
	                <FormItem
	                    {...formItemLayout}
	                    label="User Type"
	                >
                        {getFieldDecorator('user_type', {
                            rules: [
                                { required: true, message: 'Please select user type.' },
                            ],
                            initialValue: 'user'
                        })(
							<RadioGroup>
								<Radio value="user">User</Radio>
								<Radio value="admin">Admin</Radio>
							</RadioGroup>
                        )}
	                </FormItem>
	                <FormItem
	                    {...formItemLayout}
	                    label="First Name"
	                >
                        {getFieldDecorator('first_name', {
                            rules: [
                                { required: true, message: 'Please input user first name.' },
                            ],
                            validateTrigger: 'onBlur'
                        })(
                            <Input/>
                        )}
	                </FormItem>
	                <FormItem
	                    {...formItemLayout}
	                    label="Last Name"
	                >
                        {getFieldDecorator('last_name', {})(
                            <Input/>
                        )}
	                </FormItem>
	                <FormItem
	                    {...formItemLayout}
	                    label="Email"
	                >
                        {getFieldDecorator('email', {
                            rules: [
                            	{ type: 'email', message: 'This is not a valid E-mail.' },
                                { required: true, message: 'Please input user email.' },
                            ],
                            validateTrigger: 'onBlur'
                        })(
                            <Input/>
                        )}
	                </FormItem>
	                <div className="modal-footer">
	                    <Button type="primary" htmlType="submit" size="large">Save</Button>
	                </div>
	            </Form>
	        </Modal>
        )
    }
}

const WrappedUserManagementModal = Form.create()(UserManagementModal)

export default WrappedUserManagementModal


// WEBPACK FOOTER //
// ./src/Commons/UserManagementModal/UserManagementModal.js